import { TAG_GROUPS } from '@/features/discover/types/tags'

export type ExclusiveTagGroupKey = 'identity' | 'orientation' | 'position'

export function normalizeTags(input: unknown): string[] {
  const raw = Array.isArray(input) ? input : typeof input === 'string' ? [input] : []
  const seen = new Set<string>()
  const next: string[] = []

  for (const item of raw) {
    if (typeof item !== 'string') continue
    const trimmed = item.trim()
    if (!trimmed || seen.has(trimmed)) continue
    seen.add(trimmed)
    next.push(trimmed)
  }

  return next
}

export function getExclusiveTag(
  tags: string[],
  groupKey: ExclusiveTagGroupKey
): string | null {
  const group = TAG_GROUPS[groupKey]
  const groupTags = group.tags as string[]
  return tags.find((tag) => groupTags.includes(tag)) ?? null
}

export function getExclusiveTags(
  tags: string[],
  groupKey: ExclusiveTagGroupKey
): string[] {
  const normalized = normalizeTags(tags)
  const group = TAG_GROUPS[groupKey]
  const groupTags = group.tags as string[]
  return normalized.filter((tag) => groupTags.includes(tag))
}

export function hasExclusiveTag(
  tags: string[],
  groupKey: ExclusiveTagGroupKey
): boolean {
  return getExclusiveTag(tags, groupKey) !== null
}
